const useDefaultMinNumberFieldError = () => {
  return (min = 1, message?: string) => ({
    type: 'number' as const,
    min,
    message: message ?? `A duração deve ser maior ou igual a ${min}`,
  });
};

export default useDefaultMinNumberFieldError;
